import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { map, catchError } from 'rxjs/operators';
import { domain } from 'src/environments/environment';
import { GlobalProvider } from './global';
import { ToastController } from '@ionic/angular';
import { BaseHelper } from 'src/app/baseHelper';


@Injectable({
  providedIn: 'root',
})
export class CustomerApiService {
  constructor(private http: HttpClient, private g: GlobalProvider, private toastController: ToastController, private b:BaseHelper) {}
  getHeader = () => {
    return {
      headers: new HttpHeaders({
        Authorization: this.g.jws,
      }),
    };
  };

 namespace = 'customer';
  async list(params = {}) {
    const options = { ...this.getHeader(), params };
    const url = `${domain}/${this.namespace}/list`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async get(id:any) {
    const options = { ...this.getHeader() };
    const url = `${domain}/${this.namespace}/${id}/get`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async getCoupons(id:any,params = {}) {
    const options = { ...this.getHeader(), params };
    const url = `${domain}/${this.namespace}/${id}/getCoupons`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async interest(id:any,params = {}) {
    const options = { ...this.getHeader(), params };
    const url = `${domain}/${this.namespace}/${id}/interest`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async getTransaction(id:any,params = {}) {
    const options = { ...this.getHeader(), params };
    const url = `${domain}/${this.namespace}/${id}/getTransaction`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async add(data:any) {
    const url = `${domain}/${this.namespace}/add`;
    return this.http.post(url, data, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async update(id:any,data:any) {
    const url = `${domain}/${this.namespace}/${id}/update`;
    return this.http.post(url, data, this.getHeader()).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async storeList(id:any) {
    const options = { ...this.getHeader() };
    const url = `${domain}/${this.namespace}/${id}/storeList`;
    return this.http.get(url, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async couponTransaction(data:any) {
    const options = { ...this.getHeader() };
    const url = `${domain}/${this.namespace}/couponTransaction`;
    return this.http.post(url,{data}, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async couponTransactionList(data:any) {
    const options = { ...this.getHeader() };
    const url = `${domain}/${this.namespace}/couponTransactionList`;
    return this.http.post(url,{data}, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }

  async reviewList(data:any) {
    const options = { ...this.getHeader() };
    const url = `${domain}/${this.namespace}/reviewList`;
    return this.http.post(url,{data}, options).pipe(
      map((results) => results),
      catchError((error) => {
        this.errorHandle(error);
        return Promise.resolve({ ok: false });
      })
    );
  }


  errorHandle(err:any) {
    this.b.loadLoading(false);
    let message = err.error ? err.error.message : err.message;
    if (!message) message = err.error ? err.error : 'unknown error';

    this.b.toast(`${err.status}: ${message}`, 5000, `danger`);
  }
}
